// App.jsx (glue)
import { useState } from "react";
import FileUploader from "./FileUploader.jsx";
import ExcelPreviewEditor from "./ExcelPreviewEditor.jsx";
import ExcelExporter from "./ExcelExporter.jsx";
import "./ExcelPreviewEditor.css";

export default function App() {
  const [data, setData] = useState(null); // { header, rows, sectionRows }

  return (
    <div style={{ padding: 16 }}>
      <h1>Stecker Tool</h1>

      <FileUploader onDataReady={setData} />

      {data && (
        <>
          <ExcelPreviewEditor
            header={data.header}
            rows={data.rows}
            sectionRows={data.sectionRows}
            onHeaderChange={(h) => setData(d => ({ ...d, header: h }))}
            onRowsChange={(r)   => setData(d => ({ ...d, rows: r }))}
            onSectionChange={(s)=> setData(d => ({ ...d, sectionRows: s }))}
          />

          {/* render exporter only when we actually have rows */}
          {Array.isArray(data.rows) && data.rows.length > 0 && (
            <ExcelExporter
              header={data.header}
              rows={data.rows}
              sectionRows={data.sectionRows}
            />
          )}
        </>
      )}
    </div>
  );
}
